/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.portals.platform.app.rpc.NavigationRpc
 */
import * as References from './NavigationRpc';
import { createRpcClientV2, type RpcClientV2 } from 'rpc-client-utils';
import portalsHttpClient from 'portals-platform-lib/portalsHttpClient';
import {
  DataFetchingClientFetcherContext,
  RegisteredQuery,
} from 'data-fetching-client';
import { registerQuery } from 'data-fetching-client/next';
export type AdditionalContextArgs = {
  /**
   * Timeout for the request in milliseconds. If not provided, the default timeout of 5000 will be used.
   */
  timeout?: number;
  /**
   * Not recommended for usage. Please use build time client instead by updating `.client-types.config.ts`file.
   * Docs: https://product.hubteam.com/docs/chirp/pages/tutorials/chirp/FE/custom-clients.html.
   *
   * Used to overwrite the default Chirp Client during runtime.
   */
  customClient?: RpcClientV2;
};

const chirpClient = createRpcClientV2({
  hubHttpClient: portalsHttpClient,
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.portals.platform.app.rpc.NavigationRpc#getNavigationManifests
 */
export const GET_NAVIGATION_MANIFESTS_QUERY_FIELD_NAME =
  'com_hubspot_portals_platform_app_rpc_NavigationRpc_getNavigationManifests';
export const GET_NAVIGATION_MANIFESTS_QUERY: RegisteredQuery<
  'result',
  References.GetNavigationManifestsRequestType,
  References.GetNavigationManifestsResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_NAVIGATION_MANIFESTS_QUERY_FIELD_NAME,
  args: [
    'membershipToken',
    'utkCookie',
    'portalInstanceId',
    'accountId',
    'objectId',
    'membershipCsrfTokenFromClient',
    'membershipCsrfTokenFromCookie',
    'previewJwt',
    'companyId',
  ],
  fetcher(
    request: References.GetNavigationManifestsRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetNavigationManifestsResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getNavigationManifestsRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.portals.platform.app.rpc.NavigationRpc#getPortalNavigation
 */
export const GET_PORTAL_NAVIGATION_QUERY_FIELD_NAME =
  'com_hubspot_portals_platform_app_rpc_NavigationRpc_getPortalNavigation';
export const GET_PORTAL_NAVIGATION_QUERY: RegisteredQuery<
  'result',
  References.GetPortalNavigationRequestType,
  References.GetPortalNavigationResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_PORTAL_NAVIGATION_QUERY_FIELD_NAME,
  args: [
    'membershipToken',
    'utkCookie',
    'portalInstanceId',
    'accountId',
    'objectId',
    'membershipCsrfTokenFromClient',
    'membershipCsrfTokenFromCookie',
    'previewJwt',
    'companyId',
  ],
  fetcher(
    request: References.GetPortalNavigationRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetPortalNavigationResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getPortalNavigationRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.portals.platform.app.rpc.NavigationRpc#getNavigationMenu
 */
export const GET_NAVIGATION_MENU_QUERY_FIELD_NAME =
  'com_hubspot_portals_platform_app_rpc_NavigationRpc_getNavigationMenu';
export const GET_NAVIGATION_MENU_QUERY: RegisteredQuery<
  'result',
  References.GetNavigationMenuRequestType,
  References.GetNavigationMenuResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_NAVIGATION_MENU_QUERY_FIELD_NAME,
  args: [
    'membershipToken',
    'utkCookie',
    'portalInstanceId',
    'accountId',
    'objectId',
    'membershipCsrfTokenFromClient',
    'membershipCsrfTokenFromCookie',
    'previewJwt',
    'companyId',
  ],
  fetcher(
    request: References.GetNavigationMenuRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetNavigationMenuResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getNavigationMenuRpc,
      { timeout: ctx.timeout, request }
    );
  },
});
